// extracted by mini-css-extract-plugin
module.exports = {"newContB":"Sidebar_newContB__19CyI"};